import React, { FC } from "react";

import {
  IconPhotograph,
  IconRotate360Off,
  IconVideo,
} from "@at/design-system-icons";

import * as Styled from "./gallery-stats.styled";

export interface GalleryStatsProps {
  imageCount: number;
  hasSpinUrl?: boolean;
  hasVideoUrl?: boolean;
}

export const GalleryStats: FC<GalleryStatsProps> = ({
  imageCount = 0,
  hasSpinUrl,
  hasVideoUrl,
}) => {
  return (
    <Styled.Stats data-testid="stats">
      {hasSpinUrl && (
        <Styled.StatsIcon role="presentation" data-testid="360-icon">
          <IconRotate360Off title={""} />
        </Styled.StatsIcon>
      )}

      {hasVideoUrl && (
        <Styled.StatsIcon role="presentation" data-testid="video-icon">
          <IconVideo title={""} />
        </Styled.StatsIcon>
      )}

      {!!imageCount && (
        <>
          <Styled.StatsIcon role="presentation" data-testid="photos-icon">
            <IconPhotograph title={""} />
          </Styled.StatsIcon>
          <Styled.StatsText data-testid="media-types-image-count">
            {imageCount}
          </Styled.StatsText>
        </>
      )}
    </Styled.Stats>
  );
};
